import clsx from "clsx"
import { motion } from "framer-motion"

import { useComponentNavigation } from "@organisms/ComponentNavigation/ComponentNavigation.context"
import { AnimationDirectionValue } from "@organisms/ComponentNavigation/ComponentNavigation.types"

import styles from "./ComponentNavigationContent.module.scss"
import { ComponentNavigationContentProps } from "./ComponentNavigationContent.types"

export default function ComponentNavigationContent(props: ComponentNavigationContentProps) {
    const { children, animationType = "slide", className } = props
    const { animationDirection, transitionDurationMS } = useComponentNavigation()

    const getAnimationProps = () => {
        if (animationType === "slide") {
            const enterDistance = animationDirection === AnimationDirectionValue.RIGHT ? "50%" : "-50%"
            const exitDistance = animationDirection === AnimationDirectionValue.RIGHT ? "-100%" : "100%"

            return {
                initial: { x: enterDistance, opacity: 1 },
                animate: { x: 0, opacity: 1 },
                exit: { x: exitDistance, opacity: 0 },
            }
        } else if (animationType === "fade") {
            return {
                initial: { opacity: 0 },
                animate: { opacity: 1 },
                exit: { opacity: 0 },
            }
        } else {
            return {}
        }
    }

    return (
        <motion.div
            {...getAnimationProps()}
            transition={{
                duration: transitionDurationMS / 1000,
                ease: "easeOut",
            }}
            className={clsx(styles.base, className)}
        >
            {children}
        </motion.div>
    )
}
